/* global OffAmazonPayments,amazonSellerId */
<!--
  AmazonPayWidget component goes along with AmazonPayButton. They can be positioned independently
  and they depend on $store value 'payments.validAmazonSession'
-->
<template lang="pug">
  #walletWidgetDiv
  
</template>

<script>
  import { mapState, mapMutations} from 'vuex';
  import { getDefaultPayment, setAndConfirmBillingAgreement } from '../../services/vueAmazonSvc';

  export default {
    name: "AmazonPayWidget",

    data() {
      return {
        amazonBillingAgreementId: null
      }
    },

    computed: {
      ...mapState('payments', [
        'validAmazonSession'
      ])
    },

    mounted() {
      getDefaultPayment()
        .then(res => {
          this.amazonBillingAgreementId = res.data.gateway_payment_id;
          this.renderWalletWidget();
        });
    },

    methods: {
      ...mapMutations('payments', [
        'setValidAmazonSession'
      ]),

      renderWalletWidget() {
        if (!this.validAmazonSession) {
          return;
        }

        const self = this;

        new OffAmazonPayments.Widgets.Wallet({
          sellerId: amazonSellerId,
          amazonBillingAgreementId: self.amazonBillingAgreementId,

          onPaymentSelect: () => {
            var payload = {
              AmazonBillingAgreementId: self.amazonBillingAgreementId
            };

            setAndConfirmBillingAgreement(payload)
              .catch((err) => {
                var msg = 'Something went wrong. Please try again or contact Color Crew.';
                if (err.data.message) {
                  msg = err.data.message;
                }
                self.$store.dispatch('notifyError', msg);
              });
          },

          design: { designMode: 'responsive' },

          onError: (error) => {
            if (error.getErrorCode() === 'BuyerSessionExpired') {
              self.showExpiredTokenAlert();
            }
          }
        }).bind("walletWidgetDiv");
      },

      showExpiredTokenAlert() {
        this.setValidAmazonSession(false);
        this.$store.dispatch('notifyWarn', 'It looks like your amazon session expired, please log in again.');
        this.renderWalletWidget();
      }
    }
   }
</script>

<style scoped lang="stylus">
  #walletWidgetDiv
    height 270px
    padding 0.1em

</style>